// Shared by the home story, product story and first-visit intro.
if (!window.TruMotoVideoControls) {
  window.TruMotoVideoControls = class {
    constructor(video, { signal, host = video, native = true } = {}) {
      this.video = video;
      this.host = host;
      this.native = native;
      this.visible = false;
      video.controls = false;
      video.tabIndex = 0;
      const options = { signal };
      host.addEventListener('pointerdown', () => {
        this.pointerInput = true;
        this.keyboardInput = false;
        this.pointerFocus = true;
        this.keyboardFocus = false;
        this.pointerHeld = true;
        clearTimeout(this.timer);
      }, options);
      video.addEventListener('click', event => {
        // Let subsequent clicks reach the browser's playback/seek controls.
        if (!this.visible) {
          event.preventDefault();
          this.reveal();
        }
        this.pointerFocus = false;
        this.scheduleHide();
      }, options);
      video.addEventListener('focus', () => {
        if (this.pointerInput && !this.keyboardInput) return;
        this.keyboardFocus = true;
        this.reveal();
      }, options);
      video.addEventListener('blur', event => {
        this.keyboardFocus = false;
        // Touch browsers may blur without focusing the tapped overlay button.
        // Pointer controls expire on the timer or an outside tap, not focus loss.
        if (this.pointerHeld || (this.pointerInput && !this.keyboardInput)) { this.scheduleHide(); return; }
        if (event.relatedTarget && host.contains(event.relatedTarget)) return;
        this.hide();
      }, options);
      video.addEventListener('keydown', event => {
        if (!this.visible && ['Enter', ' '].includes(event.key)) {
          event.preventDefault();
          this.keyboardFocus = true;
          this.reveal();
        }
      }, options);
      host.addEventListener('pointermove', () => this.scheduleHide(), options);
      host.addEventListener('focusin', event => {
        if (this.keyboardInput && event.target.matches('button')) {
          this.keyboardFocus = true;
          this.reveal();
        }
      }, options);
      host.addEventListener('focusout', event => {
        if (this.pointerHeld || (this.pointerInput && !this.keyboardInput)) { this.scheduleHide(); return; }
        if (event.relatedTarget && host.contains(event.relatedTarget)) return;
        this.keyboardFocus = false;
        this.hide();
      }, options);
      const releasePointer = () => { this.pointerHeld = false; this.pointerFocus = false; this.scheduleHide(); };
      document.addEventListener('pointerup', releasePointer, options);
      document.addEventListener('pointercancel', releasePointer, options);
      document.addEventListener('pointerdown', event => {
        if (!host.contains(event.target)) this.hide();
      }, options);
      document.addEventListener('keydown', event => {
        this.keyboardInput = true;
        if (event.key === 'Escape') { this.keyboardFocus = false; this.hide(); }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.hide();
      }, options);
      signal?.addEventListener('abort', () => this.hide(), { once: true });
    }

    reveal() {
      this.visible = true;
      this.video.controls = this.native;
      this.host.setAttribute('data-controls-visible', '');
      this.scheduleHide();
    }

    scheduleHide() {
      clearTimeout(this.timer);
      if (!this.visible) return;
      this.timer = setTimeout(() => {
        if (this.pointerHeld || this.keyboardFocus || this.video.seeking) {
          this.scheduleHide();
          return;
        }
        this.hide();
      }, 3500);
    }

    hide() {
      clearTimeout(this.timer);
      this.visible = false;
      this.pointerHeld = false;
      this.video.controls = false;
      this.host.removeAttribute('data-controls-visible');
    }
  };
}
